import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * ThemeToggle - a fixed, always-visible control for switching between light and
 * dark themes. Rendered once at the app root so it is reachable on both the
 * empty landing screen and when a list is loaded.
 *
 * Uses toggle-button semantics: a stable `aria-label` plus `aria-pressed` to
 * convey the current state to assistive tech, rather than a label whose meaning
 * flips. The glyph shows the destination (moon = "go dark", sun = "go light"),
 * the common convention; the tooltip spells out the action.
 */
const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label="Dark mode"
      aria-pressed={isDark}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className="theme-toggle-icon" aria-hidden="true">
        {isDark ? '☀️' : '🌙'}
      </span>
    </button>
  );
};

export default ThemeToggle;
